import { useEffect } from "react";

import { useUsers } from "~/hooks";
import { Features, PortalCards } from "~/screens/Hub/Home/components";
import { WelcomeVideo } from "~/screens/Hub/Home/components/WelcomeVideo";
import { Title, usePageTitle } from "~/shared";
import { useBookingFlowStore } from "~/stores";
import HighlightedText from "~/ui/common/HighlightedText";
import { customIcons } from "~/ui/common/Icons";

export const Home = () => {
  usePageTitle("Home");
  const { getCurrentUser } = useUsers();
  const { data: currentUser, isLoading } = getCurrentUser();
  const clearBookingFlow = useBookingFlowStore((state) => state.clear);

  useEffect(() => {
    clearBookingFlow();
  }, []);

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <customIcons.SpinnerIcon className="text-violet size-10 animate-spin" />
      </div>
    );
  }

  return (
    <div className="font-sans">
      <header className="mb-8">
        <Title className="text-4xl">
          Welcome, <HighlightedText>{currentUser?.firstName}!</HighlightedText>
        </Title>
      </header>

      <section className="space-y-12">
        {currentUser?.showWelcomeVideo && (
          <WelcomeVideo className="mx-auto max-w-2xl" />
        )}

        <div className="space-y-4">
          <h2 className="text-indigo font-ivy text-2xl font-light">
            Upcoming visits
          </h2>
          <PortalCards />
        </div>

        <Features />
      </section>
    </div>
  );
};
